import React, { useEffect, useState } from 'react'
import { Typography } from '@mui/material'
import { cn } from '@src/utils/cn.ts'
import styles from '../Poll.module.scss'
import { PollComponentProps } from './PollComponentType'
import LxCancelButton from '@src/components/cancelButton/LxCancelButton'
import LxSaveButton from '@src/components/saveButton/LxSaveButton'
import { normalizeOptional } from '../Poll'

const mapProperties = (properties: any) => {
  return {
    ...properties,
    url: properties?.url || '',
    poster: properties?.poster || '/assets/images/luxai_logo_bold.png',
    btnOk: properties?.btn_ok || 'Ok',
    btnSkip: properties?.btn_skip || 'Skip',
    title: properties?.title || '',
  }
}

export const PollVideo: React.FC<PollComponentProps> = ({ data, responseCallback }) => {
  const [submitted, setSubmitted] = useState(false)
  const [canSubmit, setCanSubmit] = useState(false)
  const [isOptional, setIsOptional] = useState(false)

  const props = mapProperties(data.properties)

  const onSubmit = (skipped: boolean) => {
    setSubmitted(true)
    responseCallback({
      skipped,
      answer: {},  
    })
  }

  const onVideoEnd = () => {
    setCanSubmit(true)
  }

  // Reset on poll data change
  useEffect(() => {
    setSubmitted(false)
    setCanSubmit(false)
    setIsOptional(normalizeOptional(data?.optional))
  }, [data])

  return (
    <div className={styles.dialogContent}>
      <div className={styles.videoMain}>
        {/* Title */}
        {props.title && (
          <Typography variant="h6" component="h6" className={styles.videoTitle}>
            {props.title}
          </Typography>
        )}

        {/* Native HTML5 video player */}
        <video
          src={props.url}
          poster={props.poster}
          controls
          onEnded={onVideoEnd}
          className={styles.videoPlayer}
        />
      </div>

      {/* Footer actions */}
      <div className={styles.dialogActions}>
        {isOptional && (
          <LxCancelButton
            onCancel={() => onSubmit(true)}
            disabled={submitted}
            label={props.btnSkip}
            classNames={cn('lxActionButton', 'lxActionButtonDefaultSize', styles.pollButton)}
          />
        )}

        {canSubmit && (
          <LxSaveButton
            disabled={submitted}
            onSubmit={() => onSubmit(false)}
            label={props.btnOk}
            classNames={cn(
              'lxActionButton',
              'lxActionButtonDefaultSize',
              'lxActionButtonFilled',
              styles.pollButton
            )}
          />
        )}
      </div>
    </div>
  )
}
